// What is wrong with an order the staff is trying to check out as a return.
//
// A return is entered as a NEW order with negative quantities rather than as a
// cancellation of the original, so a 退貨單 is an ordinary order whose numbers
// all point the other way. These are the ways it can fail to be one.
//
// HARD, UNLIKE THE OVER-BALANCE WARNING. That one is a dialog the staff can
// push past, because the balance is a snapshot and being out of date is normal.
// Every check here is a mistake with no sensible "continue anyway": a positive
// total is not a return, and 折抵 on a return would take points off a customer
// who is handing goods back.
//
// IT ONLY REPORTS. The caller decides what to do, which keeps this testable
// without a form.

const at = (doc, path) =>
  path.reduce(
    (node, key) =>
      node === null || node === undefined ? undefined : node[key],
    doc,
  )

const isBlank = value => value === null || value === undefined || value === ''

// The number in a field, or null for one the staff left alone. Zero is a
// number: clearing a field and typing 0 mean the same thing here, and both are
// allowed where a redemption is not.
function numberAt(doc, path) {
  const raw = at(doc, path)
  if (isBlank(raw)) return null

  const value = Number(raw)

  return Number.isFinite(value) ? value : null
}

// Redemption is not a thing a return can do: the customer is handing goods
// back, so taking more points off them is the opposite of the intent.
const NO_REDEEM = [
  {
    path: ['spendPoints', 'value'],
    message: '退貨單不可折抵點數，請清空「折抵點數」',
  },
  {
    path: ['spendCredits', 'value'],
    message: '退貨單不可折抵購物金，請清空「折抵購物金」',
  },
]

// [] when the order is a well-formed return, which is the answer the caller
// should be cheapest to write against.
export default function returnProblems(doc) {
  const problems = []

  // The headline. `amount` is what the customer is being given back, so on a
  // return it is negative -- and a positive one means this is an ordinary sale
  // and the wrong button was pressed.
  const amount = numberAt(doc, ['amount'])
  if (amount === null) {
    problems.push('退貨單沒有金額')
  } else if (amount >= 0) {
    problems.push(`退貨單金額必須是負數（目前 ${amount}）`)
  }

  // Blank rows are ignored: the items table always keeps an empty one at the
  // end, and it is not something the staff did wrong.
  const items = at(doc, ['items'])
  const quantities = (Array.isArray(items) ? items : [])
    .map(item => (item ? Number(item.qty) : NaN))
    .filter(qty => Number.isFinite(qty) && qty !== 0)

  if (quantities.length === 0) {
    problems.push('退貨單沒有商品')
  } else if (quantities.some(qty => qty > 0)) {
    problems.push('退貨單的商品數量必須是負數')
  }

  // 贈送點數 IS UNCONSTRAINED HERE, EITHER SIGN. A clawback of what the sale
  // earned is the obvious case, but it is not the only one: a return also owes
  // back whatever was redeemed against the original order, and since 折抵 is
  // refused below, that lands in this same box. An order that spent 100 points
  // and earned 30 is returned as 贈送點數 +70.

  NO_REDEEM.forEach(check => {
    const value = numberAt(doc, check.path)

    if (value !== null && value !== 0) problems.push(check.message)
  })

  return problems
}
